import { GraphQLQuery } from 'lib/graphqlClient';

const name = 'csearchWidget_Locale';

const graphqlQuery: GraphQLQuery = {
	name,
	query: `
    query ${name}($country: String, $language: String) {
      locale(country: $country, language: $language) {
        path
        currency {
          code
        }
        country {
          code
          isoAlpha2Code
          office {
            code
          }
        }
        language {
          code
        }
      }
    }
  `,
};

export default graphqlQuery;
